import React, { useState } from "react";
import { useForm } from "react-hook-form";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import FormInputV2 from "components/FormFields/FormInputV2";
import GenericButton from "components/Buttons/GenericButton";
import { Box, Typography } from "@material-ui/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import useMessage from "hooks/useMessage";
import InactiveEmployeeConfirmationModal from "../InactiveEmployeeConfirmationModal";
import { deleteEmployeeSnapshot } from "crud/rent.crud";

const InactiveEmployeeModal = ({ open, handleClose, handleCloseDialog, employee }) => {
  const { control, handleSubmit } = useForm();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [motive, setMotive] = useState("");

  const { showSuccessMessage, showErrorMessage } = useMessage();
  const queryClient = useQueryClient();

  const { mutateAsync: deleteEmployeeSnapshotMutation, isLoading: loading } = useMutation(
    ["delete-employee-snapshot", employee?.id],
    async (data) => { 
      return await deleteEmployeeSnapshot(data);
    },
    {
      onSuccess: () => {
        showSuccessMessage("Trabalhador eliminado do Mapa RENT com sucesso.");
        queryClient.refetchQueries({ queryKey: ["listWorkCenterEmployers"], exact: true });
        setConfirmOpen(false);
        handleClose();
        handleCloseDialog();
      },
      onError: () => {
        showErrorMessage("Ocorreu um erro ao eliminar o trabalhador!");
      },
    }
  );

  const onSubmit = ({ motive }) => {
    setMotive(motive);
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    await deleteEmployeeSnapshotMutation({ snapshotId: employee?.id, motive });
  };

  return (
    <>
      <GenericDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <Typography variant="h2" color="primary" style={{ fontSize: "1.6rem", marginBottom: "2rem" }}>
          Eliminar Trabalhador
        </Typography>

        <form>
          <FormInputV2 control={control} name="motive" label="Descrição" isMultiLine required rows={4} />

          <Box display="flex" justifyContent="flex-end" gridGap={12}>
            <GenericButton color="tertiary" onClick={handleClose}>
              Cancelar
            </GenericButton>
            <GenericButton color="primary" onClick={handleSubmit(onSubmit)} loading={loading}>
              Submeter
            </GenericButton>
          </Box>
        </form>
      </GenericDialog>

      <InactiveEmployeeConfirmationModal
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleConfirm}
        employee={employee}
        loading={loading}
        motive={motive}
      />
    </>
  );
};

export default InactiveEmployeeModal;
